<template>
    <div>
        <base-crud
                crudName="Categoria de Materiais"
                newText="Nova Categoria de Materiais"
                :table="materialCategoryTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                materialCategoryTable: 'materialCategoryTable',
                materialCategories: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'photo', 'status', 'actions'],
                tableData: ['id', 'name', 'photo', 'status'],
                options: {
                    sortable: ['id', 'name', 'photo'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'name': 'Nome',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'materialCategory/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/MaterialCategory/Crud.vue